<template>
    <v-container fluid>   
      <LeftMenu/> 
        <div class="about">
            <h1>about</h1>
        </div>
    </v-container>
</template>


<script>
import LeftMenu from '../components/LeftMenu';
export default {
    components:{
      LeftMenu
    }
    
}
</script>
